import { createContext, useContext } from 'react';

type SentryContextType = {
  enabled: boolean;
};

export const SentryContext = createContext<SentryContextType>({
  enabled: false,
});

export const useSentryContext = () => useContext(SentryContext);
